<template>
  <div class="projects-page">
    <v-row><h1 class="projects-title mb-4">Work</h1></v-row>
    <v-row class="mb-4">
      <v-col v-for="(work, index) in works" :key="index" class="projects-summary content-zone">
        <h1 class="job-title pb-2">
          {{ work.position }}
        </h1>
        <h1 class="job-title pb-2">
          {{ work.company }}
        </h1>
        <p>
          {{ work.summary }}
        </p>
        <h1 class="job-title pt-2">
          {{ work.dates }}
        </h1>
      </v-col>
    </v-row>
    <!-- <v-row class="projects-controls mt-4">
      <v-col class="projects-button">
        <button class="nav-button" @click="prevProject"><v-icon>mdi-arrow-left-thin</v-icon></button>
      </v-col>
      <v-col class="projects-button"> -->
        <!-- <button class="nav-button" @click="goToProject">Go to Project</button> -->
        <!--<button class="nav-button" @click="goToProject"><v-icon>mdi-open-in-app</v-icon></button>
      </v-col>
      <v-col class="projects-button">
        <button class="nav-button" @click="nextProject"><v-icon>mdi-arrow-right-thin</v-icon></button>
      </v-col>
    </v-row> -->
  </div>
</template>

<script>
// import acImage from "@/assets/AC project.png";
export default {
  name: "WorkPage",
  data() {
    return {
      // currentIndex: 0,
      works: [
        {
          company: "Sherman Mechanical Inc.",
          position: "Project Engineer/Manager",
          dates: "March 2018 - January 2021",
          summary: "Estimated cost for bids and proposals. Designed HVAC plans based on customer desires. Managed equipment purchases, on-site workers, and coordination with other companies. Ran multiple projects valued over one million dollars in parts and labor."
        },
        {
          company: "Durex Industries",
          position: "Software Engineer",
          dates: "October 2021 - October 2024",
          summary: "Worked on a small team to build a touch screen application that tracked job progress and piece movement. Collected data was uploaded into Microsoft Great Plains ERP program. A separate view was created for managers/supervisors on traditional desktops with access to more complex features"
        },
        {
          company: "Freelance",
          position: "Website Developer",
          dates: "October 2024 - Present",
          summary: "Building responsive websites based on customer desires."
        },
      ]
    };
  },
  computed: {
    // currentProject() {
    //   return this.projects[this.currentIndex];
    // },
  },
  methods: {
    // nextProject() {
    //   if (this.currentIndex < this.projects.length - 1) {
    //     this.currentIndex++;
    //   } else {
    //     this.currentIndex = 0; // loop to start if you'd like
    //   }
    // },
    // prevProject() {
    //   if (this.currentIndex > 0) {
    //     this.currentIndex--;
    //   } else {
    //     this.currentIndex = this.projects.length - 1; // loop to end
    //   }
    // },
    // goToProject() {
    //   this.$router.push(this.currentProject.link);
    // },
  }
  
};
</script>

<style scoped>
.projects-page {
  text-align: center;
  padding: 20px;
}
.projects-summary, .projects-image, .projects-title {
  background: rgba(255, 255, 255, 0.15);
  backdrop-filter: blur(10px);
  padding: 15px;
  border-radius: 10px;
  border: 3px solid #ddaf52;
}
.projects-summary {
  display: flex;
  flex-direction: column;
  justify-content: center;
  font-size: clamp(14px, 1.6vw, 20px);
  margin-left: 1.25vw;
  margin-right: 1.25vw;
}
.projects-title {
  font-size: clamp(5vh, 5.5vw, 6vh);
  margin-left: 1.25vw;
  text-align: left;
}
.job-title {
  font-size: clamp(12px, 3vw, 24px);
}
.content-zone {
  height: 57vh;
  display: flex;
  flex-direction: column;
}
.projects-button {
  display: flex;
  flex-direction: column;
  justify-content: center;
  font-size: clamp(20px, 3vw, 36px);
  margin-left: 2.5vw;
  margin-right: 2.5vw;
}
.nav-button {
  color: #01295a;
  padding: 12px 18px;
  text-align: center;
  font-size: 18px;
  text-decoration: none;
  margin: 6px;
  font-weight: 600;
  background: rgba(255, 255, 255, 0.15);
  backdrop-filter: blur(10px);
  transition: all 0.3s ease;
  font-family: "Poppins", sans-serif;
  border: 3px solid #ddaf52;
  border-radius: 8px;
  user-select: none;
  cursor: pointer;
}
.nav-button:hover {
  color: #ffffff;
  background-color: #01295a;
  transform: scale(1.05);
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.3);
}
</style>